﻿export const PHILOSOPHY_TAGLINE = "Explore → Learn → Adapt → Act";

export const PROMPT_TAGS = {
    CORE_PHILOSOPHY: { open: "<core_philosophy>", close: "</core_philosophy>" },
    MODE: { open: "<mode>", close: "</mode>" },
    RESUME: { open: "<resume>", close: "</resume>" },
    SAFETY: { open: "<safety>", close: "</safety>" },
} as const;
